<template>
    <markets-ui-popover
        :namespaced="namespaced"
        ref="settingPopover"
        :class="namespace()"
        :visible="visible"
        :target="target"
        :skin="skin"
        :width="width"
        @hide="hidePopover"
    >
        <header
            :class="[
                mdsNS('popover__header'),
                namespace('__header'),
                skinStyle
            ]"
        >
            <div :class="namespace('__header-title')">
                <button
                    v-if="showBack"
                    :class="mdsNS('button button--icon-only')"
                    @click.stop="clickBack"
                >
                    <svg
                        :class="mdsNS('icon button__icon button__icon--right')"
                    >
                        <use xlink:href="#caret-circle-left">Back</use>
                    </svg>
                </button>
                <h3 :class="mdsNS('popover__title')">{{ title }}</h3>
            </div>
            <div :class="mdsNS('popover__buttons')" v-if="showReset">
                <button
                    :class="mdsNS('button button--icon-only')"
                    title="Reset Default"
                    @click="clickReset"
                >
                    <svg
                        :class="mdsNS('icon button__icon button__icon--right')"
                    >
                        <use xlink:href="#undo">Reset Default</use>
                    </svg>
                </button>
            </div>
            <div v-if="showDone" :class="mdsNS('popover__buttons')">
                <button
                    :class="
                        mdsNS(
                            'button button--small button--secondary popover__button'
                        )
                    "
                    :disabled="doneDisable"
                    ref="doneBtn"
                    @click="clickDone"
                >
                    {{ doneLabel }}
                </button>
            </div>
        </header>
        <div
            v-if="showSearchField"
            :class="[
                namespace('content-body__search-field'),
                mdsNS(
                    'search-field search-field--secondary search-field--small'
                )
            ]"
            role="search"
        >
            <input
                v-model="searchKey"
                type="text"
                :class="mdsNS('search-field__input')"
                aria-label="Search"
                :placeholder="searchFieldPlaceholder"
            />
            <svg
                :class="mdsNS('icon search-field__search-icon')"
                aria-hidden="true"
            >
                <use xlink:href="#search--s"></use>
            </svg>
            <span :class="mdsNS('search-field__input-focus-outline')"></span>
        </div>
        <div :class="[mdsNS('popover__content'), namespace('__content')]">
            <slot name="content"></slot>
        </div>
        <footer :class="namespace('__footer')">
            <slot name="footer"></slot>
        </footer>
    </markets-ui-popover>
</template>

<script>
import utils from '../../utils';
import mixins from '../mixins';
export default {
    name: 'markets-ui-settings',
    mixins: [mixins],
    props: {
        showBack: {
            type: Boolean,
            default: false
        },
        showDone: {
            type: Boolean,
            default: false
        },
        showSearchField: {
            type: Boolean,
            default: false
        },
        showReset: {
            type: Boolean,
            default: false
        },
        searchFieldPlaceholder: {
            type: String,
            default: 'Search'
        },
        title: {
            type: String,
            default: 'Component Settings'
        },
        doneLabel: {
            type: String,
            default: 'Done'
        },
        visible: {
            type: Boolean,
            default: false
        },
        target: {
            required: true
        },
        width: {
            type: Number,
            default: 200
        },
        doneDisable: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            searchKey: ''
        };
    },
    watch: {
        searchKey(value) {
            this.$emit('search-key-changed', value);
        }
    },
    created() {
        this.namespace = utils.namespace('ui-settings', false);
    },
    methods: {
        clickBack() {
            this.$emit('back');
            this.update();
        },
        clickDone() {
            this.$emit('done');
        },
        clickReset() {
            this.$emit('reset');
        },
        hidePopover() {
            this.searchKey = '';
            this.$emit('hide');
        },
        update() {
            this.$refs.settingPopover.update();
        }
    }
};
</script>
<style lang="scss">
$namespace: 'markets-ui-settings';
@import '../../mds/constants';
.#{$namespace} {
    &__header {
        margin-bottom: $mds-space-1-x;
        &-title {
            display: inline-flex;
            align-items: center;
            button {
                margin-right: $mds-space-three-quarter-x;
            }
        }
    }
    &__content {
        max-height: 360px;
        overflow-y: auto;
        outline: none;
        position: relative;
        margin: 0px;
        padding: 0px;
    }
    &__content {
        position: relative;
    }
    &-content-body__search-field {
        margin-bottom: $mds-space-inset-2-x;
    }
}
</style>
